import * as Sentry from '@sentry/browser';

import { Thunk } from '../custom-hooks/thunkReducer';
import { Action, State } from '../PayorderContext';
import * as payorderApi from '../services/payorderApi';

export const createPayorderContextAction =
  (validationToken: string, orderNumber: string): Thunk<State, Action> =>
  async (dispatch) => {
    // Remove any old payment or payorder context ids if
    // the url contains validation token and order number.
    dispatch({ type: 'RemoveContextIds' });

    Sentry.configureScope((scope) => {
      scope.setExtra('orderNumber', orderNumber);
      scope.setExtra('fullUrl', window.location.href);
      scope.setTag('order_number', orderNumber);
    });

    try {
      dispatch({ type: 'CreatePayorderContext' });

      const { contextId: payorderContextId } = await payorderApi.postPayorderContext({
        validationToken,
        orderNumber: parseInt(orderNumber),
        orderSource: 'ISELL',
      });
      dispatch({ type: 'CreatePayorderContextSuccess', payorderContextId });
    } catch (error) {
      dispatch({ type: 'CreatePayorderContextFailure', error });
    }
  };

export const getOrderDetailsAction =
  (payorderContextId: string): Thunk<State, Action> =>
  async (dispatch) => {
    try {
      dispatch({ type: 'GetOrderDetails' });
      const orderDetails = await payorderApi.getOrderDetails(payorderContextId);
      dispatch({ type: 'GetOrderDetailsSuccess', orderDetails });
    } catch (error) {
      dispatch({ type: 'GetOrderDetailsFailure' });
    }
  };

export const postPaymentContextAction =
  (payorderContextId: string): Thunk<State, Action> =>
  async (dispatch) => {
    try {
      dispatch({ type: 'CreatePaymentContext' });
      const { paymentContextId } = await payorderApi.postPaymentContext(payorderContextId);
      dispatch({ type: 'CreatePaymentContextSuccess', paymentContextId });
    } catch (error) {
      dispatch({ type: 'CreatePaymentContextFailure', error });
    }
  };
